var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-n3"},[_c('div',{staticClass:"d-flex flex-column items"},_vm._l((_vm.items),function(ref,keyItems){
var title = ref.title;
var path = ref.path;
return _c('v-btn',{key:keyItems,staticClass:"justify-start text-none",attrs:{"color":"grey darken-2","href":_vm.files + path,"target":"_blank","block":"","text":""}},[_c('v-icon',{attrs:{"size":"20","left":""}},[_vm._v(" fa-file-pdf ")]),_vm._v(" "+_vm._s(title)+" ")],1)}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }